export default __webpack_public_path__ + "static/media/CV1.5401ff6f.png";